module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "repo-notice-list"
  }, [_c('h2', {
    staticClass: "repo-notice-list__title"
  }, [_vm._v("回购通知书列表")]), _vm._v(" "), _c('div', {
    staticClass: "repo-notice-list__content"
  }, [_c('el-form', {
    ref: "form",
    staticClass: "repo-notice-list__search",
    attrs: {
      "inline": true,
      "model": _vm.search,
      "label-width": "90px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "项目编号"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.search.applyCode),
      callback: function($$v) {
        _vm.$set(_vm.search, "applyCode", $$v)
      },
      expression: "search.applyCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "通知书编号"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.search.noticeNo),
      callback: function($$v) {
        _vm.$set(_vm.search, "noticeNo", $$v)
      },
      expression: "search.noticeNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "项目名称"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.search.applytitle),
      callback: function($$v) {
        _vm.$set(_vm.search, "applytitle", $$v)
      },
      expression: "search.applytitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "产品名称"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.search.baseProductName),
      callback: function($$v) {
        _vm.$set(_vm.search, "baseProductName", $$v)
      },
      expression: "search.baseProductName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "search-btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.searchList
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('el-table', {
    staticClass: "repo-notice-list__table",
    staticStyle: {
      "width": "100%",
      "overflow": "hidde"
    },
    attrs: {
      "data": _vm.repoNoticeList,
      "align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "70",
      "align": "center",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "noticeNo",
      "show-overflow-tooltip": "",
      "label": "通知书编号",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "applyCode",
      "show-overflow-tooltip": "",
      "label": "项目编号",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "applytitle",
      "show-overflow-tooltip": "",
      "label": "项目名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "confirmStatusStr",
      "show-overflow-tooltip": "",
      "label": "确认状态",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createtimeStr",
      "show-overflow-tooltip": "",
      "label": "创建时间",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "btn operation",
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.goToDetail(scope.row.noticeId)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.repoNoticeList.length > 0) ? _c('el-pagination', {
    staticClass: "repo-notice-list__pagination",
    attrs: {
      "page-size": _vm.pageSize,
      "total": _vm.totalCount,
      "current-page": _vm.currentPage,
      "layout": "prev, pager, next"
    },
    on: {
      "current-change": _vm.changePage
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee366042"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/personalCenter/RepoNoticeList.vue
// module id = 1099
// module chunks = 1